// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeDurationAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeDurationAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/duration-analysis',
)({
  component: EnergyTreeNodeDurationAnalysisPage,
});
